<script>
import axios from 'axios';
import { useI18n } from 'vue-i18n';
import AppSelect from '../../shared/AppSelect.vue';

export default {
  components: { AppSelect },
  setup() {
    const i18n = useI18n();
    return {
      t: i18n.t,
    };
  },
  data() {
    return {
      scenarios: [],
    }
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    options() {
      return this.scenarios.map((scenario) => ({
        value: String(scenario.id),
        label: scenario.name,
      }));
    },
  },
  methods: {
    getCurrentLocale() {
      const metaLocale = document
        .querySelector('meta[name="current-locale"]')
        ?.getAttribute('content');
      const htmlLang = document.documentElement.getAttribute('lang');
      const raw = (metaLocale || htmlLang || 'ru').toString();
      const short = raw.split('-')[0];
      return short === 'en' ? 'en' : 'ru';
    },
    getList() {
      const url = "/api/dict/v1/scenarios";
      axios.get(url, {
        headers: {
          'Accept-Language': this.getCurrentLocale()
        }
      })
            .then(response => {
              this.scenarios = response.data;
            })
            .catch(error => {
              console.log(error);
            });
    },
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<template>
  <AppSelect
    variant="events-form"
    :model-value="modelValue"
    :options="options"
    :placeholder="t('events.form.tournament_rounds.select_scenario')"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>
